import React, { useEffect, useState } from 'react'
import * as PosService from '../../Services/pos-service'
import * as Service from '../../Services/service'
import CustomCheckBox from '../../Components/custom-checkbox/CustomCheckbox';
import { CustomAutocomplete, CustomAutocompleteAlert } from '../../Components/custom-combobox/CustomAutocomplete';
import { CustomTextField } from '../../Components/custom-textfield/CustomTextField';
import { CustomHelpText } from '../../Components/custom-help-text/CustomHelpText';
import { t } from 'i18next';
import { AddressChangeContactConst } from '../../Components/AddressChangeContactConst';

function PosRequestChangeContact({ objectDto, setObjectDto, setLoading, lang, validate }) {
    const windowSize = PosService.getSizeWindows();
    const [reasonDesc, setReasonDesc] = useState(objectDto.reasonDesc);
    const [reasonOther, setReasonOther] = useState(objectDto.reasonOther !== undefined ? objectDto.reasonOther : '');
    const [applyAll, setApplyAll] = useState(objectDto.applyAll);
    const [applyFor, setApplyFor] = useState(objectDto.applyFor);

    const [addressContactChecked, setAddressContactChecked] = useState(objectDto.changeAddressContactChecked);
    const [addressContact, setAddressContact] = useState(objectDto.changeContactDetail[0] !== undefined ? objectDto.changeContactDetail[0].address : '');
    const [provinceContact, setProvinceContact] = useState([]);
    const [selectedProvinceContact, setSelectedProvinceContact] = useState(objectDto.changeContactDetail[0] !== undefined ? objectDto.changeContactDetail[0].provinceCode : "");
    const [districtContact, setDistrictContact] = useState([]);
    const [selectedDistrictContact, setSelectedDistrictContact] = useState(objectDto.changeContactDetail[0] !== undefined ? objectDto.changeContactDetail[0].districtCode : "");
    const [wardContact, setWardContact] = useState([]);
    const [selectedWardContact, setSelectedWardContact] = useState(objectDto.changeContactDetail[0] !== undefined ? objectDto.changeContactDetail[0].wardCode : "");
    const [emailContact, setEmailContact] = useState(objectDto.changeContactDetail[0] !== undefined ? objectDto.changeContactDetail[0].emailUpDate : '')

    const [addressResidentChecked, setAddressResidentChecked] = useState(objectDto.changeAddressResidentChecked);
    const [addressResident, setAddressResident] = useState(objectDto.changeContactDetail[1] !== undefined ? objectDto.changeContactDetail[1].address : '');
    const [provinceResident, setProvinceResident] = useState([])
    const [selectedProvinceResident, setSelectedProvinceResident] = useState(objectDto.changeContactDetail[1] !== undefined ? objectDto.changeContactDetail[1].provinceCode : "");
    const [districtResident, setDistrictResident] = useState([]);
    const [selectedDistrictResident, setSelectedDistrictResident] = useState(objectDto.changeContactDetail[1] !== undefined ? objectDto.changeContactDetail[1].districtCode : "");
    const [wardResident, setWardResident] = useState([]);
    const [selectedWardResident, setSelectedWardResident] = useState(objectDto.changeContactDetail[1] !== undefined ? objectDto.changeContactDetail[1].wardCode : "");

    const [changePhoneChecked, setChangePhoneChecked] = useState(objectDto.changePhoneChecked);
    const [phoneUpDate, setPhoneUpDate] = useState(objectDto.changeContactDetail[2] !== undefined ? objectDto.changeContactDetail[2].phoneUpDate : '')

    PosService.CheckExistPlaceData(objectDto, setObjectDto, addressContactChecked, setProvinceContact, setDistrictContact, setWardContact, addressResidentChecked,
        setProvinceResident, setDistrictResident, setWardResident, setLoading);
    return (
        <div id='changeContactDiv' style={{ display: "inline-block", borderBottom: "2px solid #c4960c", marginBottom: "1%", width: "100%" }}>
            <div data-toggle="collapse" data-target="#search-box-2" className={"header-box"} id="search-box-2-header">
                <h2 className="title-box description-large-customer">
                    {lang('poschangecontact').toUpperCase()}
                </h2>
            </div>
            <div className={"collapse in"} id="search-box-2">
                <div className="form-group" id="reasonDiv">
                    <div className="col-md-4"> {/* REASONDES */}
                        <CustomAutocompleteAlert title={"Vui lòng chọn lý do thay đổi (*)"} disabled={objectDto.saved === 1}
                            data={objectDto.reasonList !== undefined ? objectDto.reasonList.map((item) => {
                                return item.descVn;
                            }) : ""}
                            onChange={(event) => {
                                setReasonDesc(event.target.textContent);
                                setObjectDto({ ...objectDto, reasonDesc: event.target.textContent })
                            }}
                            value={objectDto.reasonDesc}
                        />
                        <CustomHelpText exist={reasonDesc} hidden={(reasonDesc === '' || reasonDesc === undefined) && validate === true} />
                    </div>
                    <div className="col-md-8"> {/* REASON OTHER */}
                        {reasonDesc === "Lý do khác" ?
                            <>
                                <CustomTextField sx={{ margin: "5px 0px" }} value={reasonOther !== '' ? reasonOther : ''} fullWidth size="small" focusColor="#c4960c"
                                    label={"Vui lòng nhập lí do khác"} disabled={objectDto.saved === 1}
                                    onChange={(event) => {
                                        setReasonOther(event.target.value);
                                        setObjectDto({ ...objectDto, reasonOther: event.target.value })
                                    }}
                                />
                                <CustomHelpText exist={reasonOther} hidden={(reasonOther === '' || reasonOther === undefined) && validate === true} />
                            </>
                            : <a></a>
                        }
                    </div>
                </div>
                <div className="col-md-12" id="applyAllDiv" style={{ display: "block", marginBottom: "5px" }}> {/* Apply all */}
                    <CustomCheckBox className="iCheck-checkbox" id="checkApplyAll" value={applyAll === 0 ? false : true}
                        title={lang('posapplyall')} disabled={objectDto.saved === 1}
                        onChange={(e) => {
                            setApplyAll(e.target.checked === false ? 0 : 1);
                            const changeApplyAll = { ...objectDto, applyAll: e.target.checked === false ? 0 : 1 };
                            PosService.ProcessCheckBox(changeApplyAll, setObjectDto, setLoading);
                        }} />
                </div>

                <div className="col-md-12 form-group">
                    <div className="form-group pos-checkbox-change-contact"> {/* check contact */}
                        <CustomCheckBox className="iCheck-checkbox-contact" id="changeAddressContact" value={addressContactChecked === 0 ? false : true}
                            title={lang('posaddresscontact')} disabled={objectDto.saved === 1}
                            onChange={e => {
                                if (e.target.checked === true) {
                                    setAddressContactChecked(1);
                                    setObjectDto(prevState => ({
                                        ...prevState,
                                        changeContactDetail: prevState.changeContactDetail.map((item, index) =>
                                            index === 0 ? { ...prevState.changeContactDetail[0], address: "", provinceCode: "", districtCode: "", wardCode: "", emailUpDate: "" } : item
                                        ),
                                        changeAddressContactChecked: 1,
                                    }));
                                    PosService.FetchProvinceList(setProvinceContact, setLoading);
                                } else {
                                    setAddressContactChecked(0)
                                    setSelectedProvinceContact('');
                                    setSelectedDistrictContact('');
                                    setSelectedWardContact('');
                                    setEmailContact('');
                                    setAddressContact('');
                                    setObjectDto(prevState => ({
                                        ...prevState,
                                        changeContactDetail: prevState.changeContactDetail.map((item, index) =>
                                            index === 0 ? { ...prevState.changeContactDetail[0], address: "", provinceCode: "", districtCode: "", wardCode: "", emailUpDate: "" } : item
                                        ),
                                        changeAddressContactChecked: 0,
                                    }));
                                }
                            }}
                        />
                    </div>
                    <div className='form-group phl-border' style={{ display: addressContactChecked === 0 ? "none" : "inline-block" }} id="changeAddressContactDiv">
                        <div className="col-md-6 col-sm-12 col-xs-12" style={{ marginBottom: 10 }}> {/* address con */}
                            <CustomTextField variant="outlined" label={lang('address')} required size="small" id='addressContact'
                                value={addressContact} fullWidth focusColor="#c4960c" disabled={objectDto.saved === 1}
                                helperText={validate === true && addressContact === '' ? t('NotEmptyjavalangString') : ""}
                                onChange={(e) => {
                                    setAddressContact(e.target.value);
                                    setObjectDto(prevState => ({
                                        ...prevState,
                                        changeContactDetail: prevState.changeContactDetail.map((item, index) =>
                                            index === 0 ? { ...prevState.changeContactDetail[0], address: e.target.value } : item
                                        ),
                                    }));
                                }}
                            />
                        </div>
                        <div className="col-md-6 col-sm-12 col-xs-12" style={{ marginBottom: 10 }}> {/* province con */}
                            <CustomAutocomplete id={"provinceContract"} title={lang('province')} data={provinceContact.map((item) => { return item.name; })}
                                disabled={objectDto.saved === 1}
                                value={selectedProvinceContact !== null && selectedProvinceContact !== "" && provinceContact.length !== 0 ?
                                    PosService.getNamePlaceByCode(provinceContact, selectedProvinceContact) : ("")}
                                handleChange={(e, v) => {
                                    if (v === null) {
                                        setSelectedProvinceContact("");
                                        setSelectedDistrictContact("");
                                        setSelectedWardContact("");
                                        setDistrictContact([]);
                                        setWardContact([]);
                                        setObjectDto(prevState => ({
                                            ...prevState,
                                            changeContactDetail: prevState.changeContactDetail.map((item, index) =>
                                                index === 0 ? { ...prevState.changeContactDetail[0], provinceCode: "", districtCode: "", wardCode: "" } : item
                                            ),
                                        }));
                                    } else {
                                        provinceContact.forEach((itemProvince) => {
                                            if (itemProvince.name === v) {
                                                setSelectedProvinceContact(itemProvince.code);
                                                setWardContact([]);
                                                setSelectedDistrictContact("");
                                                setSelectedWardContact("");
                                                setObjectDto(prevState => ({
                                                    ...prevState,
                                                    changeContactDetail: prevState.changeContactDetail.map((item, index) =>
                                                        index === 0 ? { ...prevState.changeContactDetail[0], provinceCode: itemProvince.code, districtCode: "", wardCode: "" } : item
                                                    ),
                                                }));
                                                return PosService.FetchDistrictList(itemProvince.code, setDistrictContact, setLoading)
                                            }
                                        });
                                    }
                                }}
                            />
                            <CustomHelpText exist={selectedProvinceContact} hidden={(selectedProvinceContact === '' || selectedProvinceContact === undefined || selectedProvinceContact === null) && validate === true} />
                        </div>
                        <div className="col-md-6 col-sm-12 col-xs-12" style={{ marginBottom: 10 }}> {/* district con */}
                            <CustomAutocomplete id={"districtContract"} title={lang('district')} disabled={objectDto.saved === 1}
                                value={selectedDistrictContact !== null && selectedDistrictContact !== "" && districtContact.length !== 0 ? PosService.getNamePlaceByCode(districtContact, selectedDistrictContact) : ("")}
                                handleChange={(e, v) => {
                                    if (v === null) {
                                        setSelectedDistrictContact("");
                                        setSelectedWardContact("");
                                        setWardContact([]);
                                        return setObjectDto(prevState => ({
                                            ...prevState,
                                            changeContactDetail: prevState.changeContactDetail.map((item, index) =>
                                                index === 0 ? { ...prevState.changeContactDetail[0], districtCode: "", wardCode: "" } : item
                                            ),
                                        }));
                                    } else {
                                        districtContact.forEach((itemDistrict) => {
                                            if (itemDistrict.name === v) {
                                                setSelectedDistrictContact(itemDistrict.code);
                                                setSelectedWardContact("");
                                                setObjectDto(prevState => ({
                                                    ...prevState,
                                                    changeContactDetail: prevState.changeContactDetail.map((item, index) =>
                                                        index === 0 ? { ...prevState.changeContactDetail[0], districtCode: itemDistrict.code, wardCode: "" } : item
                                                    ),
                                                }));
                                                return PosService.FetchWardList(itemDistrict.code, setWardContact, setLoading)
                                            }
                                        });
                                    }
                                }}
                                data={districtContact.map((item) => {
                                    return item.name;
                                })}
                            />
                            <CustomHelpText exist={selectedDistrictContact} hidden={(selectedDistrictContact === '' || selectedDistrictContact === undefined || selectedDistrictContact === null) && validate === true} />
                        </div>
                        <div className="col-md-6 col-sm-12 col-xs-12" style={{ marginBottom: 10 }}> {/* ward con */}
                            <CustomAutocomplete id={"wardContract"} title={lang('ward')} disabled={objectDto.saved === 1}
                                value={selectedWardContact !== null && selectedWardContact !== "" && wardContact.length !== 0 ?
                                    PosService.getNamePlaceByCode(wardContact, selectedWardContact) : ("")}
                                handleChange={(e, v) => {
                                    if (v === null) {
                                        setSelectedWardContact("");
                                        return setObjectDto(prevState => ({
                                            ...prevState,
                                            changeContactDetail: prevState.changeContactDetail.map((item, index) =>
                                                index === 0 ? { ...prevState.changeContactDetail[0], wardCode: 0 } : item
                                            ),
                                        }));
                                    } else {
                                        wardContact.forEach((itemWard) => {
                                            if (itemWard.name === v) {
                                                setSelectedWardContact(itemWard.code);
                                                return setObjectDto(prevState => ({
                                                    ...prevState,
                                                    changeContactDetail: prevState.changeContactDetail.map((item, index) =>
                                                        index === 0 ? { ...prevState.changeContactDetail[0], wardCode: itemWard.code } : item
                                                    ),
                                                }));
                                            }
                                        })
                                    }
                                }}
                                data={wardContact.map((item) => { return item.name })}
                            />
                            <CustomHelpText exist={selectedWardContact} hidden={(selectedWardContact === '' || selectedWardContact === undefined || selectedWardContact === null) && validate === true} />
                        </div>


                        <div className="col-md-6 col-sm-12 col-xs-12"> {/* email con */}
                            <CustomTextField variant="outlined" label={lang('email')} size="small" required={objectDto.emailNotChecked === 1 ? false : true} fullWidth focusColor="#c4960c" disabled={objectDto.saved === 1}
                                value={emailContact} helperText={!Service.ValidateEmail(emailContact) && emailContact !== '' && emailContact !== null ? t("errormessageinvalidemail") : ""}
                                onChange={(e) => {
                                    setEmailContact(e.target.value);
                                    setObjectDto(prevState => ({
                                        ...prevState,
                                        changeContactDetail: prevState.changeContactDetail.map((item, index) =>
                                            index === 0 ? { ...prevState.changeContactDetail[0], emailUpDate: e.target.value } : item
                                        ),
                                    }));
                                }}
                            />
                        </div>
                        <div className="col-md-12 col-sm-12 col-xs-12 pos-checkbox-apply-for"> {/* apply for */}
                            <CustomCheckBox className="iCheck-checkbox" id="checkApplyFor" value={applyFor === 0 ? false : true}
                                title={lang('posapplyfor')} disabled={objectDto.saved === 1}
                                onChange={e => {
                                    setApplyFor(e.target.checked === true ? 1 : 0);
                                    const changeApplyFor = { ...objectDto, applyFor: e.target.checked === true ? 1 : 0 };
                                    PosService.ProcessCheckBox(changeApplyFor, setObjectDto, setLoading);
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-12 form-group" hidden={applyFor === 1}>
                    <div className="form-group pos-checkbox-change-contact"> {/* checkbox res */}
                        <CustomCheckBox className="iCheck-checkbox-contact" id="changeAddressResident" value={addressResidentChecked === 1 ? true : false}
                            title={lang('posaddressresident')} disabled={objectDto.saved === 1}
                            onChange={e => {
                                if (e.target.checked) {
                                    setAddressResidentChecked(1);
                                    PosService.FetchProvinceList(setProvinceResident, setLoading);
                                    setSelectedProvinceResident('');
                                    setSelectedDistrictResident('');
                                    setSelectedWardResident('');
                                    setAddressResident('');
                                    setObjectDto(prevState => ({
                                        ...prevState,
                                        changeContactDetail: prevState.changeContactDetail.map((item, index) =>
                                            index === 1 ? { ...prevState.changeContactDetail[1], address: "", provinceCode: "", districtCode: "", wardCode: "" } : item
                                        ),
                                        changeAddressResidentChecked: 1,
                                    }));
                                } else {
                                    setAddressResidentChecked(0);
                                    setSelectedProvinceResident('');
                                    setSelectedDistrictResident('');
                                    setSelectedWardResident('');
                                    setAddressResident('');
                                    setObjectDto(prevState => ({
                                        ...prevState,
                                        changeContactDetail: prevState.changeContactDetail.map((item, index) =>
                                            index === 1 ? { ...prevState.changeContactDetail[1], address: "", provinceCode: "", districtCode: "", wardCode: "" } : item
                                        ),
                                        changeAddressResidentChecked: 0,
                                    }));
                                }
                            }}
                        />
                    </div>
                    <div className='form-group phl-border' style={{ display: addressResidentChecked === 1 ? "flow-root" : "none", paddingBottom: "0px" }} id="changeAddressResidentDiv">
                        <div className="col-md-6 col-sm-12 col-xs-12" style={{ marginBottom: 10 }}> {/* address res */}
                            <CustomTextField variant="outlined" label="Địa chỉ" required size="small" fullWidth focusColor="#c4960c"
                                disabled={objectDto.saved === 1}
                                value={addressResident} onChange={(e) => {
                                    setAddressResident(e.target.value);
                                    setObjectDto(prevState => ({
                                        ...prevState,
                                        changeContactDetail: prevState.changeContactDetail.map((item, index) =>
                                            index === 1 ? { ...prevState.changeContactDetail[1], address: e.target.value } : item
                                        ),
                                    }));
                                }}
                                helperText={validate === true && addressResident === '' ? t('NotEmptyjavalangString') : ""}
                            />
                        </div>
                        <div className="col-md-6 col-sm-12 col-xs-12" style={{ marginBottom: 10 }}> {/* province res */}
                            <CustomAutocomplete id={"provinceResident"} title={lang('province')} disabled={objectDto.saved === 1}
                                value={selectedProvinceResident !== null && selectedProvinceResident !== "" && provinceResident.length !== 0 ?
                                    PosService.getNamePlaceByCode(provinceResident, selectedProvinceResident) : ("")}
                                handleChange={(e, v) => {
                                    if (v === null) {
                                        setSelectedProvinceResident("");
                                        setSelectedDistrictResident("");
                                        setSelectedWardResident("");
                                        setDistrictResident([]);
                                        setWardResident([]);
                                        return setObjectDto(prevState => ({
                                            ...prevState,
                                            changeContactDetail: prevState.changeContactDetail.map((item, index) =>
                                                index === 1 ? { ...prevState.changeContactDetail[1], provinceCode: "", districtCode: "", wardCode: "" } : item
                                            ),
                                        }));
                                    } else {
                                        provinceResident.forEach((itemProvince) => {
                                            if (itemProvince.name === v) {
                                                setSelectedProvinceResident(itemProvince.code);
                                                setWardResident([]);
                                                setSelectedDistrictResident("");
                                                setSelectedWardResident("");
                                                setObjectDto(prevState => ({
                                                    ...prevState,
                                                    changeContactDetail: prevState.changeContactDetail.map((item, index) =>
                                                        index === 1 ? { ...prevState.changeContactDetail[1], provinceCode: itemProvince.code, districtCode: "", wardCode: "" } : item
                                                    ),
                                                }));
                                                return PosService.FetchDistrictList(itemProvince.code, setDistrictResident, setLoading)
                                            }
                                        });
                                    }
                                }}
                                data={provinceResident.map((item) => { return item.name })}
                            />
                            <CustomHelpText exist={selectedProvinceResident} hidden={(selectedProvinceResident === '' || selectedProvinceResident === undefined || selectedProvinceResident === null) && validate === true} />
                        </div>
                        <div className="col-md-6 col-sm-12 col-xs-12" style={{ marginBottom: 10 }}> {/* district res */}
                            <CustomAutocomplete id={"districtResident"} title={lang('district')} disabled={objectDto.saved === 1}
                                value={selectedDistrictResident !== null && selectedDistrictResident !== "" && districtResident.length !== 0 ?
                                    PosService.getNamePlaceByCode(districtResident, selectedDistrictResident) : ("")}
                                handleChange={(e, v) => {
                                    if (v === null) {
                                        setSelectedDistrictResident("");
                                        setSelectedWardResident("");
                                        setWardResident([]);
                                        return setObjectDto(prevState => ({
                                            ...prevState,
                                            changeContactDetail: prevState.changeContactDetail.map((item, index) =>
                                                index === 1 ? { ...prevState.changeContactDetail[1], districtCode: "", wardCode: "" } : item
                                            ),
                                        }));
                                    } else {
                                        districtResident.forEach((itemDistrict) => {
                                            if (itemDistrict.name === v) {
                                                setSelectedDistrictResident(itemDistrict.code);
                                                setSelectedWardResident("");
                                                setObjectDto(prevState => ({
                                                    ...prevState,
                                                    changeContactDetail: prevState.changeContactDetail.map((item, index) =>
                                                        index === 1 ? { ...prevState.changeContactDetail[1], districtCode: itemDistrict.code, wardCode: "" } : item
                                                    ),
                                                }));
                                                return PosService.FetchWardList(itemDistrict.code, setWardResident, setLoading)
                                            }
                                        });
                                    }
                                }}
                                data={districtResident.map((item) => { return item.name })}
                            />
                            <CustomHelpText exist={selectedDistrictResident} hidden={(selectedDistrictResident === '' || selectedDistrictResident === undefined ||
                                selectedDistrictResident === null) && validate === true} />
                        </div>
                        <div className="col-md-6 col-sm-12 col-xs-12" style={{ marginBottom: 10 }}> {/* ward res */}
                            <CustomAutocomplete id={"wardResident"} title={lang('ward')} disabled={objectDto.saved === 1}
                                value={PosService.getNamePlaceByCode(wardResident, selectedWardResident)}
                                data={wardResident.map((item) => { return item.name })}
                                handleChange={(e, v) => {
                                    if (v === null) {
                                        setSelectedWardResident("");
                                        return setObjectDto(prevState => ({
                                            ...prevState,
                                            changeContactDetail: prevState.changeContactDetail.map((item, index) =>
                                                index === 1 ? { ...prevState.changeContactDetail[1], wardCode: "" } : item
                                            ),
                                        }));
                                    } else {
                                        wardResident.forEach((itemWard) => {
                                            if (itemWard.name === v) {
                                                setSelectedWardResident(itemWard.code);
                                                return setObjectDto(prevState => ({
                                                    ...prevState,
                                                    changeContactDetail: prevState.changeContactDetail.map((item, index) =>
                                                        index === 1 ? { ...prevState.changeContactDetail[1], wardCode: itemWard.code } : item
                                                    ),
                                                }));
                                            }
                                        })
                                    }
                                }}
                            />
                            <CustomHelpText exist={selectedWardResident} hidden={(selectedWardResident === '' || selectedWardResident === undefined ||
                                selectedWardResident === null) && validate === true} />
                        </div>
                    </div>
                </div>

                <div class="col-md-12 form-group">
                    {/* <input type="hidden" th:field="*{changePhoneChecked}"></input>
                        <input type="hidden" th:field="*{changeContactDetail[2].transactionTypeSubId}"></input>
                        <input type="hidden" th:field="*{changeContactDetail[2].transactionTypeId}"></input>
                        <input type="hidden" th:field="*{changeContactDetail[2].transactionTypeSub}"></input> */}

                    <div className="form-group pos-checkbox-change-contact"> {/* checkbox phone */}
                        <CustomCheckBox className="iCheck-checkbox-contact" id="changePhone" value={changePhoneChecked === 1 ? true : false}
                            title={lang('posphonecontact')} disabled={objectDto.saved === 1}
                            onChange={e => {
                                if (e.target.checked === true) {
                                    setChangePhoneChecked(1);
                                    const updateObjectDto = { ...objectDto, 'changePhoneChecked': 1 };
                                    // objectDto.changePhoneChecked = 1;
                                    PosService.ProcessCheckBox(updateObjectDto, setObjectDto, setLoading);
                                } else {
                                    setChangePhoneChecked(0);
                                    // setObjectDto(preSt => ({ ...preSt, 'changePhoneChecked': 0 }))
                                    // objectDto.changePhoneChecked = 0;
                                    const updateObjectDto = { ...objectDto, 'changePhoneChecked': 0 };
                                    PosService.ProcessCheckBox(updateObjectDto, setObjectDto, setLoading);
                                }
                            }}
                        />
                    </div>


                    <div style={{ display: changePhoneChecked === 1 ? "flow-root" : "none", paddingBottom: "10px" }} id="changePhoneDiv" class="form-group phl-border">
                        <div className="col-md-6 col-sm-12 col-xs-12">
                            <CustomTextField variant="outlined" label={lang('phone')} id="change-phone" required size="small" fullWidth
                                value={phoneUpDate} focusColor="#c4960c" disabled={objectDto.saved === 1}
                                helperText={validate === true && phoneUpDate === '' ? t('NotEmptyjavalangString') : ""}
                                onChange={(e) => {
                                    if (e.target.value.length <= 10) {
                                        setPhoneUpDate(e.target.value);
                                        setObjectDto(prevState => ({
                                            ...prevState,
                                            changeContactDetail: [
                                                ...prevState.changeContactDetail.slice(0, 2),
                                                { ...prevState.changeContactDetail[2], phoneUpDate: e.target.value },
                                            ],
                                        }));
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PosRequestChangeContact;

